import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import TipsAndTricksItem from '../TipsAndTricksItem';

interface AdviceResponse {
  content: Record<string, { title: string; content: string }>;
}

interface Props {
  content: string[];
  adviceResponseObject: AdviceResponse;
}

const TipsAndTricks = ({ content, adviceResponseObject }: Props) => {
  if (!content || !content.length) return null;

  return (
    <div className="mt-6 lg:mt-5 lg:bg-main-light lg:px-5 lg:py-4 lg:rounded-[5px]">
      <p className="text-2xl font-bold lg:text-xl">Tips & tricks</p>
      <p className="text-sm mt-1 lg:text-lg lg:mt-2.5">Naast producten ook nog wat handige tips & tricks</p>
      {content.map((itemIndex) => {
        const item = adviceResponseObject.content[itemIndex];
        if (item) return <TipsAndTricksItem key={uuidv4()} item={item} />;
      })}
    </div>
  );
};

export default TipsAndTricks;
